import request from '@/utils/request'

// 查询列表
export function apiTSysInventoryOrganizationWarehouseList (query) {
  return request({
    url: '/mdm/tSysInventoryOrganizationWarehouse/list',
    method: 'get',
    params: query
  })
}

// 下拉列表
export function apiWorkShopDescList (query) {
  return request({
    url: '/mdm/tSysInventoryOrganizationWarehouse/workShopDescList',
    method: 'get',
    params: query
  })
}

// 修改
export function apiWorkShopDescUpdate (data) {
  return request({
    url: '/mdm/tSysInventoryOrganizationWarehouse',
    method: 'put',
    data: data
  })
}
